

document.addEventListener('DOMContentLoaded', function () {

  function initAccordion() {

    // Primary menu
    document.querySelectorAll('.menu-drawer__menu-item--mainlist').forEach(function (item) {
      if (item._bound) return;
      item._bound = true;

      item.addEventListener('click', function (e) {
        var parent = item.closest('.menu-drawer__list-item--flat');
        if (!parent) return;

        var childList = parent.querySelector('.menu-drawer__menu--childlist');
        var hasChildren = childList !== null;

        if (hasChildren) {
          e.preventDefault();
          parent.classList.toggle('is-open');
        }
        // hasChildren nahi — normal redirect
      });
    });

    // Secondary menu
    document.querySelectorAll('.drawer-secondary-link').forEach(function (link) {
      if (link._bound) return;
      link._bound = true;

      link.addEventListener('click', function (e) {
        var parent = link.closest('.drawer-secondary-menu > li');
        if (!parent) return;

        // Check karo child submenu hai ya nahi
        var submenu = parent.querySelector('.drawer-submenu');
        var hasChildren = submenu !== null;

        if (hasChildren) {
          e.preventDefault();
          parent.classList.toggle('is-open');
        }
        // hasChildren nahi — normal redirect
      });
    });
  }

  initAccordion();
  document.addEventListener('on:header-drawer:open', initAccordion);

});

(function() {
  const TARGET_CLASS = 'filter-padding-active';
  const GRID_SELECTOR = 'ul[data-testid="product-grid"]';

  function checkFilters() {
    const params = new URLSearchParams(window.location.search);
    
    const hasActiveFilter = [...params.keys()].some(key => 
      key.startsWith('filter.')
    );

    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;

    if (hasActiveFilter) {
      grid.classList.add(TARGET_CLASS);
    } else {
      grid.classList.remove(TARGET_CLASS);
    }
  }

  // MutationObserver - DOM change hone pe check karo
  const observer = new MutationObserver(function() {
    checkFilters();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // URL change intercept
  const _pushState = history.pushState.bind(history);
  history.pushState = function(...args) {
    _pushState(...args);
    setTimeout(checkFilters, 300);
  };

  const _replaceState = history.replaceState.bind(history);
  history.replaceState = function(...args) {
    _replaceState(...args);
    setTimeout(checkFilters, 300);
  };

  window.addEventListener('popstate', checkFilters);

  // Page load
  document.addEventListener('DOMContentLoaded', checkFilters);
  window.addEventListener('load', checkFilters);

})();


function updateSwatchTicks() {

  document.querySelectorAll(
    'swatches-variant-picker-component .swatch'
  ).forEach((swatch) => {

    const style = swatch.getAttribute('style');

    if (!style) return;

    const match = style.match(/rgb\((\d+)\s+(\d+)\s+(\d+)\)/);

    if (!match) return;

    const r = parseInt(match[1]);
    const g = parseInt(match[2]);
    const b = parseInt(match[3]);

    const brightness =
      ((r * 299) + (g * 587) + (b * 114)) / 1000;

    swatch.style.setProperty(
      '--tick-color',
      brightness > 150 ? '#000' : '#fff'
    );
  });
}

/* Initial run */
document.addEventListener('DOMContentLoaded', updateSwatchTicks);

/* Re-run after variant changes */
document.addEventListener('change', function(e){

  if(e.target.matches(
    'swatches-variant-picker-component input'
  )){
      setTimeout(updateSwatchTicks, 50);
  }

});


function toggleFilterPills() {

    const pills = document.querySelector(
        '.facets-remove--mobile-and-vertical'
    );

    if(!pills) return;

    const filterSection = document.querySelector(
        '.facets.facets--vertical'
    );

    if(!filterSection) return;

    const sectionTop =
        filterSection.getBoundingClientRect().top;

    if(sectionTop <= 120){

        pills.style.opacity = '0';
        pills.style.visibility = 'hidden';
        pills.style.pointerEvents = 'none';

    } else {

        pills.style.opacity = '1';
        pills.style.visibility = 'visible';
        pills.style.pointerEvents = 'auto';

    }
}

/* Scroll hide/show */
window.addEventListener('scroll', toggleFilterPills);

/* Initial load */
document.addEventListener(
    'DOMContentLoaded',
    toggleFilterPills
);

/* Filter select */
document.addEventListener('change', function(e){

    if(
        e.target.closest('.facets__filters-wrapper')
    ){

        const filterSection = document.querySelector(
            '.facets.facets--vertical'
        );

        const pills = document.querySelector(
            '.facets-remove--mobile-and-vertical'
        );

        if(filterSection){

            window.scrollTo({
                top: filterSection.offsetTop - 120,
                behavior: 'smooth'
            });

        }

        /* Show pills after filter select */
        if(pills){

            pills.style.opacity = '1';
            pills.style.visibility = 'visible';
            pills.style.pointerEvents = 'auto';

        }

    }

});

/* Shopify rerender */
const observer = new MutationObserver(() => {
    toggleFilterPills();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});




(function() {
    var target = document.querySelector('results-list');
    if (!target) return;

    var observer = new MutationObserver(function() {
      frcp.wishlist.attachOnCollection();
    });

    observer.observe(target, { childList: true, subtree: true });
  })();

/* =========================
   PERSONALIZATION
========================= */

function initPersonalization(container = document){

    const personalizationFieldset = container.querySelector(
        'fieldset[data-option-id*="personalization"]'
    );

    const customField = container.querySelector(
        '.custom-personalization-field'
    );

    const inputField = container.querySelector(
        'input[name="properties[Personalized Text]"]'
    );

    const addToCartBtn = container.querySelector(
        'button[name="add"]'
    );

    if (
        !personalizationFieldset ||
        !customField ||
        !inputField ||
        !addToCartBtn
    ) {
        return;
    }

    function validate(){

        const checkedRadio = personalizationFieldset.querySelector(
            'input[type="radio"]:checked'
        );

        if(!checkedRadio) return;

        const selectedValue = checkedRadio.value.toLowerCase();

        /* =========================
           SHOW / HIDE FIELD
        ========================= */

        if(selectedValue === 'personalized'){

            customField.style.display = 'block';

            /* =========================
               EMPTY FIELD
            ========================= */

            if(inputField.value.trim() === ''){

                addToCartBtn.disabled = true;
                addToCartBtn.style.opacity = '0.5';
                addToCartBtn.style.cursor = 'not-allowed';

                inputField.style.borderColor = 'red';

            } else {

                addToCartBtn.disabled = false;
                addToCartBtn.style.opacity = '1';
                addToCartBtn.style.cursor = 'pointer';

                inputField.style.borderColor = '#d9d9d9';

            }

        } else {

            customField.style.display = 'none';

            addToCartBtn.disabled = false;
            addToCartBtn.style.opacity = '1';
            addToCartBtn.style.cursor = 'pointer';

            inputField.style.borderColor = '#d9d9d9';

        }

    }

    personalizationFieldset.addEventListener('change', function(){

        setTimeout(validate, 100);

    });

    inputField.addEventListener('input', validate);

    validate();

}


/* =========================
   MAIN PDP
========================= */

document.addEventListener('DOMContentLoaded', function(){

    initPersonalization(document);

});


/* =========================
   QUICK VIEW
========================= */

document.addEventListener('click', function(){

    setTimeout(() => {

        document.querySelectorAll('quick-add-dialog').forEach((dialog) => {

            initPersonalization(dialog);

        });

    }, 700);

});

// View Full Details 
function injectViewFullBtn(dialog) {
  if (dialog.querySelector('.view-full-details-btn')) return;

  const addToCartButtons = dialog.querySelector('.product-form-buttons');
  if (!addToCartButtons) return;

  const productForm = dialog.querySelector('product-form-component');
  const url = productForm ? productForm.getAttribute('data-product-url') : '#';

  const btn = document.createElement('a');
  btn.href = url || '#';
  btn.className = 'view-full-details-btn';
  btn.textContent = 'View Full Details';

  addToCartButtons.appendChild(btn);
}

// Modal open hone pe catch karo
document.addEventListener('click', function() {
  setTimeout(function() {
    document.querySelectorAll('quick-add-dialog').forEach(function(dialog) {
      // Har click pe fresh inject try karo
      dialog._viewInjected = false;
      injectViewFullBtn(dialog);
    });
  }, 300);

  setTimeout(function() {
    document.querySelectorAll('quick-add-dialog').forEach(function(dialog) {
      injectViewFullBtn(dialog);
    });
  }, 800);

  setTimeout(function() {
    document.querySelectorAll('quick-add-dialog').forEach(function(dialog) {
      injectViewFullBtn(dialog);
    });
  }, 1500);
});

// DOM change pe bhi catch karo
const quickViewObserver = new MutationObserver(function() {
  document.querySelectorAll('quick-add-dialog').forEach(function(dialog) {
    injectViewFullBtn(dialog);
  });
});

quickViewObserver.observe(document.body, { childList: true, subtree: true });


  document.addEventListener('DOMContentLoaded', function() {
    // Apne specific URL ko target karne ke liye
    var giftCardLinks = document.querySelectorAll('a[href*="giftcard.arcisgolf.com"]');
    
    giftCardLinks.forEach(function(link) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    });
  });








  